import type { FreightMatching } from "@x-mile/api-contract";

export const ContractStatusLabels = [
  { status: "contract_concluded" },
  { status: "rejected_by_them" },
  { status: "waiting_response" },
] as const;

export type CONTRACT_STATUS = (typeof ContractStatusLabels)[number]["status"];

export const isContractStatus = (
  arg: string | undefined | null,
): arg is CONTRACT_STATUS =>
  !!arg && ContractStatusLabels.some((status) => status.status === arg);

export const calculateContractOfferCargoStatus = (
  contractOfferCargo: FreightMatching.schemas.OfferCargo,
): CONTRACT_STATUS => {
  // stage=contract_concluded => 成約
  if (contractOfferCargo.stage === "contract_concluded") {
    return "contract_concluded";
  }

  // rejectが存在する => 見送り
  if (contractOfferCargo.rejection !== undefined) {
    return "rejected_by_them";
  }

  // それ以外 => 合意まち
  return "waiting_response";
};
